import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@tenancy.nz/design-system';
import StyledContentImg from './ContentImg.styled';

function ContentImg({animation, src, ...rest}) {
  const variants = {
    zoomIn: {
      hidden: {opacity: 0, scale: 0.75},
      show: {
        opacity: 1,
        scale: 1,
        transition: {delay: 0.3, ease: 'easeOut', duration: 0.5},
      },
    },
    zoomInBounce: {
      hidden: {opacity: 0, scale: 0.75},
      show: {
        opacity: 1,
        scale: 1,
        y: ['10px', '-10px'],
        transition: {
          y: {
            duration: 1.5,
            yoyo: Infinity,
            ease: 'easeInOut',
          },
          scale: {duration: 0.5},
        },
      },
    },
  };
  return (
    <Box maxWidth={{xs: '50%', md: '83%'}} flex="1" {...rest}>
      <StyledContentImg
        {...(animation && {
          variants: variants[animation],
          animate: 'show',
          initial: 'hidden',
        })}
        src={src}
      />
    </Box>
  );
}

ContentImg.propTypes = {
  animation: PropTypes.string,
  src: PropTypes.string.isRequired,
};

ContentImg.defaultProps = {
  animation: undefined,
};

export default ContentImg;
